// extracted by mini-css-extract-plugin
module.exports = {"bar":"_5D37i2ad","description":"_5D1DktVo","form":"_5D1sXoyc"};